<template>
  <div>
    <b-card border-variant="dark" class="mt-4">
      <div class="height-queue">
        <div id="queue-header">
          <span class="font-weight-bold font-15">Em atendimento</span>

          <div class="d-flex justify-content-between">
            <input
              type="text"
              name="search"
              class="form-control mr-5"
              placeholder="Pesquisar..."
              v-model="search"
            />

            <select class="form-control" v-model="attFilter">
              <option value="*">Todos</option>
              <option value="ativo">Atendimentos Ativos</option>
              <option value="receptivo">Atendimentos Receptivos</option>
            </select>
          </div>
        </div>

        <b-table
          id="queue"
          small
          striped
          bordered
          fixed
          :per-page="perPage"
          :fields="fields"
          :items="items"
          responsive="sm"
          class="mt-2"
          :current-page="currentPage"
          show-empty
        >
          <template #empty="scope">
            <h6 class="text-center">Nenhum cliente em atendimento</h6>
          </template>

          <template #cell(time)="data">
            <span v-if="getTime(data.item.time)">
              <b-badge :variant="getTime(data.item.time).variant">
                {{ getTime(data.item.time).val }}
              </b-badge>
            </span>
            <span v-else>—</span>
          </template>

          <template #cell(queue)="data">
            <span :class="data.item.queue == 'Ativo' ? 'text-danger font-weight-bold' : ''">
              {{ data.item.queue }}
            </span>
          </template>

          <template #cell(opcao)="data">
            <i
              title="Visualizar conversa"
              id="action-button-view"
              class="image-button fa fa-eye"
              @click.prevent="abrirVisualizar(data.item.opcao)"
            ></i>

            <i
              title="Excluir atendimento"
              id="action-button-delete"
              class="image-button fas fa-trash"
              @click.prevent="limparUra(data.item.opcao)"
            ></i>

            <i
              title="Direcionar atendimento"
              id="action-button-transfer"
              class="image-button fa fa-angle-double-right"
              @click="openModalTransf(data.item.opcao)"
            ></i>
          </template>
        </b-table>

        <b-pagination
          v-model="currentPage"
          pills
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="queue"
          size="sm"
          align="right"
        ></b-pagination>
      </div>
    </b-card>

    <dtModalVisualizar ref="dtModalVisualizar" />
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
const socket = require('./../../../modules/realtime/service/service');

export default {
  name: "TbFilaAndamento",
  props: ['queues', 'userChatQueues'],

  data: () => ({
    fields: [
      { key: 'operator', label: 'Operador', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },
      { key: 'queue', label: 'Fila', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },
      { key: 'nome', label: 'Cliente', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },
      { key: 'fone', label: 'Telefone', class: 'text-center align-middle', thStyle: { width: "160px", 'font-weight': 'bold' } },
      { key: 'time', label: 'Tempo', class: 'text-center align-middle', thStyle: { width: '70px', 'font-weight': 'bold' } },
      { key: 'opcao', label: 'Ações', class: 'text-center align-middle', thStyle: { width: "70px", 'font-weight': 'bold' } }
    ],
    currentPage: 1,
    perPage: 10,
    users: [],
    attFilter: '*',
    search: '',
  }),

  created() {
    axios.get('/realtime/listUsers', {}).then(({ data }) => {
      this.users = data;
    });
  },

  computed: {
    ...mapGetters([
      "getUserRealtime"
    ]),

    items() {
      let table = this.mountTable();

      if (this.attFilter === 'receptivo') {
        table = table.filter(val => val.queue !== 'Ativo');
      } else if (this.attFilter === 'ativo') {
        table = table.filter(val => val.queue === 'Ativo');
      }

      if (this.search && String(this.search).trim()) {
        const searchLower = String(this.search).toLowerCase().trim();
        const searchClean = String(this.search).replace(/\D/g, '');

        table = table.filter((val) => {
          const foneClean = String(val.fone || '').replace(/\D/g, '');
          const nomeLower = String(val.nome || '').toLowerCase();
          const queueLower = String(val.queue || '').toLowerCase();
          const operatorLower = String(val.operator || '').toLowerCase();

          return (
            nomeLower.includes(searchLower) ||
            operatorLower.includes(searchLower) ||
            queueLower.includes(searchLower) ||
            (searchClean && foneClean.includes(searchClean))
          );
        });
      }

      return table;
    },

    rows() {
      return this.items.length;
    }
  },

  methods: {
    ...mapMutations(['setUserRealtime', 'setUserRealtimeData']),
    ...mapActions(['transferOptions']),

    async abrirVisualizar(idUsers) {
      await this.setUserRealtime(idUsers);

      if (this.getUserRealtime) {
        await this.checkChatRealtime();
        await socket.connection.emit('newEntryRealtimeUsers', { idUsers });
        this.$refs.dtModalVisualizar.openModal();
      }
    },

    getItems() {
      if (this.attFilter == 'receptivo') {
        this.items = this.mountTable().filter((val) => {
          if (val.queue != 'Ativo') return true;
        });
      } else if (this.attFilter == 'ativo') {
        this.items = this.mountTable().filter((val) => {
          if (val.queue == 'Ativo') return true;
        });
      } else {
        this.items = this.mountTable();
      }
    },

    getTime(time) {
      if (typeof time !== 'number' || isNaN(time)) {
        return { val: '--:--:--', variant: 'secondary' };
      }

      let horas = ("00" + parseInt(time / 3600)).slice(-2);
      time = time - (horas * 3600);

      let minutos = ("00" + parseInt(time / 60)).slice(-2);
      time = time - (minutos * 60);

      let segundos = ("00" + parseInt(time)).slice(-2);

      const format = `${horas}:${minutos}:${segundos}`;

      if (parseInt(horas) < 1 && parseInt(minutos) < 30) {
        return { val: format, variant: 'success' };
      } else if (parseInt(horas) < 3) {
        return { val: format, variant: 'warning' };
      } else {
        return { val: format, variant: 'danger' };
      }
    },

    formTelefone(tel) {
      tel = String(tel || '');

      if (!tel) return '';

      if (tel.substr(0, 2) != '55') {
        return '+' + tel;
      }

      if ((tel.length == 10) || (tel.length == 11)) {
        const v1 = tel.replace(/\D/g, "");
        const v2 = v1.replace(/^(\d{2})(\d)/g, "($1) $2");
        const v3 = v2.replace(/(\d)(\d{4})$/, "$1-$2");
        return v3;
      }

      tel = tel.replace(/\D/g, "");
      tel = tel.replace(/^(\d)/, "+$1");
      tel = tel.replace(/(.{3})(\d)/, "$1($2");
      tel = tel.replace(/(.{6})(\d)/, "$1)$2");

      if (tel.length == 12) {
        tel = tel.replace(/(.{1})$/, "-$1");
      } else if (tel.length == 13) {
        tel = tel.replace(/(.{2})$/, "-$1");
      } else if (tel.length == 14) {
        tel = tel.replace(/(.{3})$/, "-$1");
      } else if (tel.length == 15) {
        tel = tel.replace(/(.{4})$/, "-$1");
      } else if (tel.length > 15) {
        tel = tel.replace(/(.{4})$/, "-$1");
      }

      tel = tel.replace("(", " (");
      tel = tel.replace(")", ") ");

      return tel;
    },

    limparUra(client) {
      Swal.fire({
        title: 'Remover do Atendimento?',
        text: `Você tem certeza que deseja remover este cliente ${this.formTelefone(client)} do atendimento?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: 'rgb(28,134,154)',
        confirmButtonText: 'Sim, remover',
        cancelButtonText: 'Cancelar'
      }).then((isConfirm) => {
        if (isConfirm.value) socket.connection.emit('queueUraDelete', { client });
      });
    },

    mountTable() {
      const now = moment().format('YYYY-MM-DD HH:mm:ss');

      return (this.queues || [])
        .filter(q => this.userChatQueues.includes(q.queue))
        .map(q => {
          const ms = moment(now).diff(moment(q.created_at));

          const clientId = q.client_id
            ?? q.clientId
            ?? q.client
            ?? '';

          const nomeCliente = q.cName
            ?? q.cname
            ?? q.name
            ?? q.nome
            ?? q.client_name
            ?? q.client
            ?? '';

          console.log('[TbFilaAndamento] item fila:', q);
          console.log('[TbFilaAndamento] nome resolvido:', nomeCliente);

          const userOp = this.users.find(o => o.extension_line == q.operator);

          return {
            operator: userOp ? userOp.nome : q.operator,
            fone: this.formTelefone(clientId),
            nome: String(nomeCliente),
            queue: q.queue === 'entrante' ? 'Ativo' : q.queue,
            time: Number(moment.duration(ms).asSeconds()),
            opcao: clientId
          };
        })
        .sort((a, b) => a.time - b.time);
    },

    async checkChatRealtime() {
      if (this.getUserRealtime) {
        socket.connection.on('newEntryRealtime', async (data) => {
          let key = Object.keys(data)[0];

          if (this.getUserRealtime == key) {
            const objReturn = [];
            const dataCheck = [];

            data[key].msgs.forEach(function (msg) {
              let dt = msg.data.trim().split(" ");
              let sepData = {
                'data': dt[0],
                'hora': dt[1]
              };

              let exibirData = '';
              if (!dataCheck.includes(sepData.data)) {
                dataCheck.push(sepData.data);
                exibirData = sepData.data;
              }

              const obj = {
                isProprio: msg.type,
                exibirData: exibirData,
                data: sepData.data,
                hora: sepData.hora,
                mensagem: msg.mensagem,
                avatar: msg.isProprio ? meuAvatar : data[key].avatar,
                idOperador: data[key].operador
              };

              objReturn.push(obj);
            });

            this.setUserRealtimeData(objReturn);
          }
        });
      }
    },

    openModalTransf(dado) {
      this.$emit('open-modal-transf', dado);
    },
  },

  watch: {
    async queues() {
      await this.checkChatRealtime();
      await this.transferOptions();
    },
  }
}
</script>

<style scoped>
#queue-header {
  display: flex;
  flex-direction: column;
}

.card {
  color: black !important;
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
  border-radius: 0.25rem !important;
}

.font-15 {
  font-size: 15px;
}

.height-queue {
  /* height: 205px; */
}

#action-button-view {
  cursor: pointer;
  font-size: 16px;
  color: #1c869a;
  transition: 0.25s;
  margin: 5px;
}

#action-button-view:hover {
  color: #177081;
}

#action-button-delete {
  cursor: pointer;
  font-size: 16px;
  color: #e3342f;
  transition: 0.25s;
  margin: 5px;
}

#action-button-delete:hover {
  color: #b42a26;
}

#action-button-transfer {
  cursor: pointer;
  font-size: 16px;
  color: #d99c3a;
  transition: 0.25s;
  margin: 5px;
}

#action-button-transfer:hover {
  color: #92641a;
}

on-delete:hover {
  color: #b42a26;
}
</style>